import { useEffect, useState } from "react";
import { url } from "../utils/config";
import axios from "axios";
import FaqInfo from "../child_components/FaqInfo";
import AddFaq from "../modals/AddFaq";
import Table from "../reusable_components/Table";
import Button from "../reusable_components/Button";
import { title, btnOneNoWidth } from "../utils/style";

function Faqs() {
    const [ faqInfo, setFaqInfo ] = useState(null);
    const [ faqIndex, setFaqIndex ] = useState();
    const [ showAddFaq, setShowAddFaq ] = useState(false);
    const [ reloadTable, setReloadTable ] = useState(false)


    // async function fetchFaqInfo(id, ind) {
    //     try {
    //         const reqUrl = url + '/faq_info/' + id;
    //         const token = window.localStorage.getItem('token');
    //         const headers = { authorization: `bearer ${token}` };
    //         const { data } = await axios.get(reqUrl, { headers });
    //         console.log(data);
    //         setFaqIndex(ind);
    //         setFaqInfo(data);
    //     } catch (error) {
    //         console.log(error)
    //     }
    // }

    const options = [
        {
            header: 'S. No.',
            key: 'id'
        },
        {
            header: 'Make',
            render: (data) => { return data.car.make },
            filterKey: 'make'
        },
        {
            header: 'Model',
            render: (data) => { return data.car.model },
            filterKey: 'model'
        },
        {
            header: 'Year',
            render: (data) => { return data.car.year },
            filterKey: 'year'
        },
        {
            header: 'Problem',
            key: 'problem'
        },
        {
            header: 'Solution',
            key: 'solution'
        },
    ]

    const excludeFilter = ['S. No.']


    return(
        <div className="p-4">
            {
                // faqInfo != null && <FaqInfo setShowModal={setFaqInfo} faqInfo={{ ...faqInfo, ...faqs[faqIndex] }}  />
            }
            {
                showAddFaq && <AddFaq setShowModal={setShowAddFaq} reload={setReloadTable} />
            }
            <div className="flex justify-between items-center mb-4">
                <div className={title}>FAQs</div>
                {(
                    <Button className={`${btnOneNoWidth}`} name={`Add FAQ`} clickHandler={() => setShowAddFaq(!showAddFaq)} />
                )}
            </div>
            <Table 
                options={options} 
                url={url + '/faqs'} 
                pagination 
                clickHandler={() => setShowAddFaq(!showAddFaq)}
                btnTitle={'FAQ'}
                excludeFilter={excludeFilter}
                reloadTable={reloadTable}
                noButton={true}
            />
        </div>
    )

}

export default Faqs;